import classNames from 'classnames';
const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
export const createTitle = (Tag) => {
    class Title extends React.Component {
        static defaultProps = {
            prefix: 'next-',
        };
        render() {
            const { prefix, className, ...others } = this.props;
            return (createElement(Text, { ...others, component: Tag, className: `${className || ''} ${prefix}typography-title` }));
        }
    }
    Title.displayName = Tag.toUpperCase();
    return Title;
};
export const isProduction = () => {
    const PRODUCTION_ENV = 'production';
    let result = false;
    try {
        if (process.env.NODE_ENV === PRODUCTION_ENV) {
            result = true;
        }
    }
    catch (err) {
    }
    return result;
};
export const textTypeMap = {
    'body-1': 'body2',
    'body-2': 'body1',
    subhead: 'h6',
    title: 'h5',
    headline: 'h4',
    'display-1': 'h3',
    'display-2': 'h2',
    'display-3': 'h1',
};
const Text = (props, ref) => {
    const { prefix, className, type, component = 'span', strong, underline, delete: deleteProp, code, mark, required, ...others } = props;
    let { children } = props;
    const newType = textTypeMap[type] || type;
    const cls = classNames(className, {
        [`${prefix}text`]: true,
        [`${prefix}text-${newType}`]: newType,
    });
    if (typeof children === 'string' && children.indexOf('\n') !== -1) {
        const childrenList = children.split('\n');
        const newChildren = [];
        childrenList.forEach((child) => {
            newChildren.push(child);
            newChildren.push(createElement("br", null));
        });
        newChildren.pop();
        children = newChildren;
    }
    const Tag = component;
    if (strong) {
        children = createElement("strong", null, children);
    }
    if (underline) {
        children = createElement("u", null, children);
    }
    if (deleteProp) {
        children = createElement("del", null, children);
    }
    if (code) {
        children = createElement("code", null, children);
    }
    if (mark) {
        children = createElement("mark", null, children);
    }
    return (createElement(Tag, { ...others, className: cls, ref: ref, style: { marginRight: '2px' } },
        children,
        required && createElement("span", { style: { color: 'red', marginLeft: '5px' } }, "*")));
};
const RefText = React.forwardRef(Text);
RefText.defaultProps = {
    prefix: 'next-',
};
const Paragraph = (props) => {
    const { prefix, className, component, ...others } = props;
    console.log('props', props);
    const cls = classNames(`${prefix}text-paragraph`, className);
    if (!isProduction()) {
        console.warn('Warning: Text.Paragraph is deprecated, use P instead');
    }
    return (createElement(Text, { ...others, className: cls, component: component }));
};
RefText.H1 = createTitle('h1');
RefText.H2 = createTitle('h2');
RefText.H3 = createTitle('h3');
RefText.H4 = createTitle('h4');
RefText.H5 = createTitle('h5');
RefText.H6 = createTitle('h6');
RefText.Paragraph = Paragraph;
export default RefText;
